'use client';

import { FC, useState } from 'react';
import {
  cvaAddress,
  cvaHowToGet,
  cvaHowToGetDescr,
  cvaHowToGetTitle,
  cvaPhone,
  cvaPhoneIcon,
  cvaRoot,
  cvaTimeAndPrice,
  cvaTimeToPvz,
  cvaTimeToPvzDescr,
  cvaTimeToPvzTitle,
  cvaTitle,
  cvaWorkingHours,
  cvaWorkingHoursIcon,
} from './PvzMapDetailsHeaderStyles';
import IconCalendar from '/public/icons/calendar.svg';
import IconPhone from '/public/icons/phone2.svg';
import ShevronDown from '~/icons/shevron_down.svg';

interface Props {
  address: string;
  workingHours?: string;
  phone?: string;
  howToGet?: string;
  timeToPvz?: string;
  deliveryPrice: string;
}

const PvzMapDetailsHeader: FC<Props> = ({ address, deliveryPrice, workingHours, phone, howToGet }) => {
  const [revealHowToGet, setRevealHowToGet] = useState(false);
  const [revealWorkingHours, setRevealWorkingHours] = useState(false);

  const showWorkingHoursRevealButton = (workingHours?.length || 0) > 50;
  const showHowToGetRevealButton = (howToGet?.length || 0) > 50;

  return (
    <div className={cvaRoot()}>
      <div className={cvaTitle()}>Подробнее о пункте выдачи</div>
      <address className={cvaAddress()}>{address}</address>
      <div className={cvaWorkingHours()}>
        <IconCalendar className={cvaWorkingHoursIcon()} />{' '}
        <p className={`${revealWorkingHours ? '' : 'truncate'} max-w-[30rem]`}>{workingHours}</p>
        {showWorkingHoursRevealButton ? (
          <button
            onClick={() => setRevealWorkingHours((prevState) => !prevState)}
            className="flex items-center gap-0.5 text-bodyMSemibold decoration-dashed underline text-cBlack leading-none underline-offset-8 decoration-cBlack64"
          >
            {revealWorkingHours ? 'Свернуть' : 'Развернуть'}
            <ShevronDown className={`w-1.6 h-1.6 ${revealWorkingHours ? 'rotate-180' : ''}`} />
          </button>
        ) : null}
      </div>
      {phone ? (
        <a href={`tel:${phone}`} className={cvaPhone()}>
          <IconPhone className={cvaPhoneIcon()} /> {phone}
        </a>
      ) : null}
      {howToGet ? (
        <dl className={cvaHowToGet()}>
          <dt className={cvaHowToGetTitle()}>Как добраться</dt>
          <dd
            className={cvaHowToGetDescr({
              revealed: revealHowToGet,
            })}
          >
            {howToGet}
          </dd>
          {showHowToGetRevealButton ? (
            <button
              onClick={() => setRevealHowToGet((prevState) => !prevState)}
              className="flex items-center gap-0.5 text-bodyMSemibold decoration-dashed underline text-cBlack leading-none underline-offset-8 decoration-cBlack64"
            >
              {revealHowToGet ? 'Свернуть' : 'Развернуть'}
              <ShevronDown className={`w-1.6 h-1.6 ${revealHowToGet ? 'rotate-180' : ''}`} />
            </button>
          ) : null}
        </dl>
      ) : null}
      {/* todo: кнопка развернуть */}
      <div className={cvaTimeAndPrice()}>
        <dl className={cvaTimeToPvz()}>
          <dt className={cvaTimeToPvzTitle()}>Срок хранения заказа</dt>
          <dd className={cvaTimeToPvzDescr()}>7 дней</dd>
        </dl>
        <dl className={cvaTimeToPvz()}>
          <dt className={cvaTimeToPvzTitle()}>Стоимость доставки</dt>
          <dd className={cvaTimeToPvzDescr()}>{deliveryPrice}</dd>
        </dl>
      </div>
    </div>
  );
};

export default PvzMapDetailsHeader;
